import { render, staticRenderFns } from "./OffworkAutoreply.vue?vue&type=template&id=52a29d44&scoped=true"
import script from "./OffworkAutoreply.vue?vue&type=script&lang=js"
export * from "./OffworkAutoreply.vue?vue&type=script&lang=js"
import style0 from "./OffworkAutoreply.vue?vue&type=style&index=0&id=52a29d44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a29d44",
  null
  
)

export default component.exports